module.exports = __webpack_public_path__ + "static/media/IMG_1128.f07257d6.jpg";